import React, { useState, useEffect, Fragment, useContext } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import SchoolSellerSchedules from './SchoolSellerSchedules';

const ScheduleSeller = () => {

	const authContext = useContext(AuthContext);
	const { getSchoolID, schoolID } = authContext;

	useEffect(() => {
		getSchoolID();
    }, []);

	return (

		<SchoolSellerSchedules 
			schoolID={schoolID}
		/>

	);
};

export default ScheduleSeller;
